import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [RouterModule.forChild([        
        { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./entrada-listar/entrada-listar.module').then(m => m.EntradaListarModule) },
        { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./entrada-editar/entrada-editar.module').then(m => m.EntradaEditarModule) },
        { path: 'inserir', data: { breadcrumb : 'Novo' }, loadChildren: () => import('./entrada-inserir/entrada-inserir.module').then(m => m.EntradaInserirModule) },
        { path: 'detalhar', data: { breadcrumb : 'Detalhar' }, loadChildren: () => import('./entrada-detalhar/entrada-detalhar.module').then(m => m.EntradaDetalharModule) }
    ])],
    exports: [RouterModule]
})
export class EntradaAppRoutingModule { }